import React from 'react'
import AdminScoutsStep from './AdminScoutsStep'

const AdminScouts = () => {
  return (
    <div className='AdminDashboard'>
    <div className='AdminPage_Dashboard'>
        <div className='AdminPage_DashboardTAbleCat'>
            <AdminScoutsStep />
            </div>
    </div>
    </div>
  )
}

export default AdminScouts